export const resources = {
  en: {
    translation: {
      app: {
        language: "Language",
        region: "Region",
      },
      auth: {
        brand_tagline: "Financial Intelligence Platform",
        welcome_back: "Welcome Back",
        welcome_back_desc: "Sign in to your account to continue.",
        email: "Email",
        password: "Password",
        sign_in: "Sign In",
        signing_in: "Signing in…",
        no_account: "Don't have an account?",
        create_one: "Create one",
        create_account: "Create Account",
        how_using: "How will you be using BBA Services?",
        already_have: "Already have an account?",
        sign_in_link: "Sign in",
      },
      onboarding: {
        welcome_title: "Welcome to BBA Financial Intelligence",
        welcome_subtitle:
          "Let's set up your experience so the AI can guide you in the right direction from day one.",
        which_describes: "Which best describes you?",
        continue: "Continue",
        back: "Back",
        quick_setup: "Quick Setup",
        quick_setup_desc: "Just 2 questions to personalize your workspace",
        what_call_you: "What should we call you?",
        name_placeholder: "Your first name or business name",
        business_structure: "What's your business structure?",
        country: "Country",
        language: "Language",
        start_intake: "Start AI Intake",
        ai_intake_title: "AI Intake & Routing Engine",
        step_of: "Step {{current}} of {{total}}",
        select_option: "Select an option",
        type_answer: "Type your answer",
        yes: "Yes",
        no: "No",
      },
      views: {
        dashboard: "Financial Intelligence Dashboard",
        clients: "Client Portfolio",
        documents: "Document Intelligence Center",
        transactions: "Bookkeeping & Transaction Review",
        financials: "Financial Statements",
        returns: "Tax Return Management",
        ai: "AI Strategy & Insights",
        efileSettings: "IRS E-File Configuration",
        prompts: "AI System Prompts Management",
        reports: "Reports & Intelligence Center",
        calendar: "Tax & Business Calendar",
        systemHealth: "System Health & Performance Monitoring",
        bulkTest: "Bulk Prior Year Import Test Suite",
        clientDetail: "Client Detail",
        reportDetail: "Report Detail",
      },
      efile: {
        integrationTitle: "IRS E-File Integration",
        integrationDescription: "Connect to IRS Modernized e-File (MeF) system for electronic filing",
        connected: "Connected",
        connectTitle: "Connect to IRS E-File System",
        connectDescription:
          "Authenticate with your IRS e-file credentials to enable electronic filing of tax returns directly from BBA Services.",
        connectAction: "Connect to IRS",
        authAction: "Authenticate",
        authPending: "Authenticating...",
        cancel: "Cancel",
        submissionTitle: "E-File Submission",
        noProvider: "No e-file provider connected. Please configure IRS e-file authentication first.",
      },
    },
  },
  es: {
    translation: {
      app: {
        language: "Idioma",
        region: "Región",
      },
      auth: {
        brand_tagline: "Plataforma de Inteligencia Financiera",
        welcome_back: "Bienvenido de nuevo",
        welcome_back_desc: "Inicia sesión en tu cuenta para continuar.",
        email: "Correo electrónico",
        password: "Contraseña",
        sign_in: "Iniciar sesión",
        signing_in: "Iniciando sesión…",
        no_account: "¿No tienes una cuenta?",
        create_one: "Crear una",
        create_account: "Crear cuenta",
        how_using: "¿Cómo vas a usar BBA Services?",
        already_have: "¿Ya tienes una cuenta?",
        sign_in_link: "Iniciar sesión",
      },
      onboarding: {
        welcome_title: "Bienvenido(a) a BBA Financial Intelligence",
        welcome_subtitle:
          "Configuremos tu experiencia para que la IA pueda guiarte en la dirección correcta desde el primer día.",
        which_describes: "¿Cuál te describe mejor?",
        continue: "Continuar",
        back: "Atrás",
        quick_setup: "Configuración rápida",
        quick_setup_desc: "Solo 2 preguntas para personalizar tu espacio",
        what_call_you: "¿Cómo te llamamos?",
        name_placeholder: "Tu nombre o el de tu negocio",
        business_structure: "¿Cuál es la estructura de tu negocio?",
        country: "País",
        language: "Idioma",
        start_intake: "Iniciar Intake con IA",
        ai_intake_title: "Motor de Intake y Enrutamiento con IA",
        step_of: "Paso {{current}} de {{total}}",
        select_option: "Selecciona una opción",
        type_answer: "Escribe tu respuesta",
        yes: "Sí",
        no: "No",
      },
      views: {
        dashboard: "Panel de Inteligencia Financiera",
        clients: "Cartera de Clientes",
        documents: "Centro de Inteligencia Documental",
        transactions: "Revisión Contable y de Transacciones",
        financials: "Estados Financieros",
        returns: "Gestión de Declaraciones",
        ai: "Estrategia e Insights de IA",
        efileSettings: "Configuración de Declaración Electrónica IRS",
        prompts: "Gestión de Prompts del Sistema de IA",
        reports: "Centro de Reportes e Inteligencia",
        calendar: "Calendario Fiscal y Empresarial",
        systemHealth: "Monitoreo de Salud y Rendimiento del Sistema",
        bulkTest: "Suite de Pruebas de Carga Masiva de Años Anteriores",
        clientDetail: "Detalle del Cliente",
        reportDetail: "Detalle del Reporte",
      },
      efile: {
        integrationTitle: "Integración con Declaración Electrónica IRS",
        integrationDescription: "Conecta con el sistema IRS Modernized e-File (MeF) para declaración electrónica",
        connected: "Conectado",
        connectTitle: "Conectar con el Sistema de Declaración IRS",
        connectDescription:
          "Autentícate con tus credenciales IRS para habilitar la presentación electrónica de declaraciones desde BBA Services.",
        connectAction: "Conectar con IRS",
        authAction: "Autenticar",
        authPending: "Autenticando...",
        cancel: "Cancelar",
        submissionTitle: "Envío Electrónico",
        noProvider: "No hay proveedor de declaración electrónica conectado. Configura primero la autenticación IRS.",
      },
    },
  },
} as const;
